/* eslint-disable import/no-unresolved */

import jQuery from 'jquery';
import initApp from 'app';
import cookieAlert from 'cookiealert';
import { initVariantsTable, handleProductVariantsChange } from 'variants';
import { initCheckboxVisibilityToggle, taxonsAndFiltersExpansion, rewriteAddressBookDataToForm, productBoxesTouchEvents, isTouchEnabled, initContactForm } from 'helpers';
import { initSpinners } from 'cart';
import { productModalInitAndShow, clearCartInit } from 'modals';
// import initInpost from 'inpost';
import Splide from 'splide/js/splide';
import GLightbox from 'glightbox/glightbox.min';

// import { setSearchBox, extendAutocomplete, searchInit } from './modules/search';

/* global $, window, document, observer */

window.jQuery = jQuery;
window.$ = window.jQuery;

let navTimer;

(() => {
  $.fn.isInViewport = function f() {
    const elementTop = $(this).offset().top;
    const elementBottom = elementTop + $(this).outerHeight();
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

	// Update Header Style and Scroll to Top
	function headerStyle() {
		if($('.main-header').length){
      const windowpos = $(window).scrollTop();
      const siteHeader = $('.main-header');
      const scrollLink = $('.scroll-top');
      if (windowpos >= 175) {
				siteHeader.addClass('fixed-header');
				scrollLink.addClass('open');
			} else {
				siteHeader.removeClass('fixed-header');
				scrollLink.removeClass('open');
			}
		}
	}

	headerStyle();

	$(window).on('scroll', function() {
		headerStyle();
	});

  $(document).ready(() => {
    initApp($);
    cookieAlert();

    if ($('.icon-boxes-carousel').length) {
      new Splide('.icon-boxes-carousel', {
        type: 'loop',
        mediaQuery: 'min',
        perPage: 1,
        breakpoints: {
          768: {
            perPage: 2,
          },
          1200: {
            perPage: 3,
          },
          1920: {
            perPage: 4,
          },
        },
        gap: '2rem',
        padding: '0.1rem',
        arrows: false,
      }).mount();
    }

    if ($('.banner-carousel').length) {
      new Splide('.banner-carousel', {
        autoplay: true,
        arrows: false,
        type: 'fade',
        pauseOnHover: false,
        pauseOnFocus: true,
        resetProgress: false,
        rewind: true,
        rewindSpeed: 500,
        speed: 7000,
        pagination: true,
      }).mount();
    }

    const galleryLightbox = GLightbox({
      selector: '.block-gallery a',
      touchNavigation: true,
      loop: true,
    });

    const lawsuitLightbox = GLightbox({
      selector: '.project-details-content .image-box a',
      touchNavigation: true,
      loop: true,
    });

    // Submenu Dropdown Toggle
    if ($('.main-header li.dropdown ul').length) {
      $('.main-header .navigation li.dropdown').append('<div class="dropdown-btn"><span class="fas fa-angle-down"></span></div>');
    }

    // First Letter Highlight
    if ($('.project-details-content').length) {
      const paragraph = $('.project-details-content .text-box p').first();
      const paragraphText = paragraph.text();
      const firstChar = paragraphText.charAt(0);
      const remainingText = paragraphText.slice(1);
      const newHtml = '<span class="first-letter">' + firstChar + '</span>' + remainingText;

      paragraph.html(newHtml);
    }

    // Mobile Nav Hide Show
    if ($('.mobile-menu').length) {

      // $('.mobile-menu .menu-box').mCustomScrollbar();

      var mobileMenuContent = $('.main-header .menu-area .main-menu').html();
      $('.mobile-menu .menu-box .menu-outer').append(mobileMenuContent);

      // Dropdown Button
      $('.mobile-menu li.dropdown .dropdown-btn').on('click', function() {
        $(this).toggleClass('open');
        $(this).prev('ul').slideToggle(500);
      });
      // Menu Toggle Btn
      $('.mobile-nav-toggler').on('click', function() {
        $('body').addClass('mobile-menu-visible');
      });

      // Menu Toggle Btn
      $('.mobile-menu .menu-backdrop, .mobile-menu .close-btn').on('click', function() {
        $('body').removeClass('mobile-menu-visible');
      });
    }

    handleProductVariantsChange();
    initVariantsTable();
    initSpinners(1);
    taxonsAndFiltersExpansion();
    rewriteAddressBookDataToForm();
    /* toggles showing additional address form */
    initCheckboxVisibilityToggle();
    clearCartInit();
    // extendAutocomplete(window.$);
    // searchInit(navTimer);

    if (isTouchEnabled()) {
      productBoxesTouchEvents($('.list-product-area'));
      productBoxesTouchEvents($('.iso-section-products'));

      $('body').on('touchstart', (e) => {
        if (!$(e.target).closest('.shop-product-card').length) {
          $('.shop-product-card').removeClass('hovered');
        }
      });
    }

    if ($('.contact-form').length) initContactForm();
    // if ($('#selectInpostPointModal').length) initInpost();

    /* quickview modal open */
    $('.shop-product-card .buy-btn, .saved-cart-link, .cart-item-link').on('click', function f(e) {
      productModalInitAndShow(e, $(this), { modalType: 'quickView' });
    });

    /* user account current page highlighted in menu */
    $('.iso-page-account .shop-account-menu .nav-link').each(function f() {
      const currentURL = window.location.href;
      if (currentURL.indexOf($(this).attr('href')) !== -1) {
        $(this).addClass('active').attr('aria-current', 'page');
      }
    });

    const filtersSelected = $('#mobileFilters .filters-widget .filter-option-selected').length;
    if (filtersSelected > 0) {
      $('#headingFilters .material-symbols-outlined').after(`<span class="fw-bold">(${filtersSelected})</span>`);
    }

    const $shippingCalculator = $('.iso-shipping-calculator');
    $shippingCalculator.find('input[type="radio"]').on('click change', function sc() {
      $($shippingCalculator.data('total-selector')).html($(this).parents('.radio-container').find('.extra').data('order-total'));
      $($shippingCalculator.data('shipping-payment-selector')).html($(this).parents('.radio-container').find('.extra').data('shipping-payment'));
    });

    /* no method selected will throw an error */
    if (!$shippingCalculator.find('input[type=radio]:checked').length) {
      $shippingCalculator.find('input[type=radio]').first().attr('checked', 'checked').prop('checked', true);
    }
  });

  $(window).on('load', () => {
    /* scroll to first form error if not in viewport */
    const $invalid = $('.is-invalid');
    if ($invalid.length) {
      if (!$invalid.isInViewport()) {
        $('html, body').animate({
          scrollTop: $invalid.first().offset().top - 140,
        }, 1000);
      }
    }

    if ($('.image-box .row div').length) {
      const msnry = new Masonry('.image-box .row', {
        // options...
      });

      msnry.once('layoutComplete', () => {
        $('.image-box').addClass('masonry');
      });

      setTimeout(() => {
        msnry.layout();
      }, 500);
    }

    $('.block-gallery').each(function g() {   
      const $gallery = $(this).find('.row').first();   
      if ($gallery.find('.col').length) {
        const galleryMsnry = new Masonry($gallery[0], {
          itemSelector: '.col',
          percentPosition: true,
        });

        galleryMsnry.once('layoutComplete', () => {
          $(this).addClass('masonry');
        });

        setTimeout(() => {
          galleryMsnry.layout();
        }, 500);
      }
    });
  }).scroll(() => {
    if ($(window).scrollTop() > 20) {
      $('.top-bar').addClass('page-scrolled', 300);
    } else {
      $('.top-bar').removeClass('page-scrolled', 300);
    }
  });
})();
